import React from "react";

class Answered extends React.Component {
    render() {
        return (
            <>
                <div className="host-container">
                    <div className="top-bar">
                        <div>NAME - {this.props.user}</div>
                        <div>QUESTION - {this.props.data.currentQuestion} / {this.props.data.totalQuestions}</div>
                        <div>ROOM - {this.props.code}</div>
                    </div>
                    <div className="localFont">
                        WAIT FOR OTHERS TO FINISH
                    </div>
                </div>
            </>
        );
    }
}

export default Answered;